<template>
  <div class="container" :class="{ logged: logged }">
    <div class="icon-container">
      <div class="floating front">
        <img v-if="dataImageUrl" :src="dataImageUrl" @error="handleError" />
      </div>
      <div class="floating back">
        <i class="fas fa-user" :class="{ logged: logged }"></i>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import FontAwesome from "@/public/js/lib/FontAwesomeKit"; // <--- importing FontAwesome icons

// Props
type Props = {
  imageUrl?: string | null;
  logged?: boolean;
};
const { imageUrl, logged }: Props = withDefaults(defineProps<Props>(), {
  imageUrl: null,
  logged: false,
});

// Data
const errorImageUrl = ref(false);

// Computed
const dataImageUrl = computed(() => {
  if (errorImageUrl.value) return null;
  return imageUrl;
});

// Methods
const handleError = () => {
  errorImageUrl.value = true;
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/variables.scss";

$SIZE: 2.5em;

.container {
  width: $SIZE;
  height: $SIZE;
  border-radius: 100%;
  border: 1px solid var(--pallete_dark_text_color);
  background-color: var(--background_02);

  &.logged {
    border-color: var(--pallete_main_color);
  }
}

.icon-container {
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;

  .floating {
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    &.front {
      z-index: 10;
    }

    &.back {
      z-index: 5;
    }
  }

  i {
    text-align: center;
    margin: auto;
    color: var(--pallete_dark_text_color);

    &.logged {
      color: var(--pallete_main_color);
    }
  }

  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
}
</style>
